import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import { i18n } from '@/i18n'
import { queryClient } from '@/lib/queryClient'
import { createAppRouter } from '@/router'

import './styles.css'

const app = createApp(App)

// Pinia first: the router's navigation guard reads the auth store, and a guard
// runs before the app is mounted.
app.use(createPinia())
// i18n before the router: the navigation guard's afterEach sets the document
// title from a translated route key, and it can run before the first paint.
app.use(i18n)
// The shared instance, not a fresh one: the auth store empties this exact
// cache on every sign-out and sign-in (lib/queryClient.ts says why).
app.use(VueQueryPlugin, { queryClient })
app.use(createAppRouter())

app.mount('#app')
